import { render, staticRenderFns } from "./arbitrage-order-detail-inquiry.vue?vue&type=template&id=074b8050&scoped=true&"
import script from "./arbitrage-order-detail-inquiry.vue?vue&type=script&lang=js&"
export * from "./arbitrage-order-detail-inquiry.vue?vue&type=script&lang=js&"
import style0 from "./arbitrage-order-detail-inquiry.vue?vue&type=style&index=0&id=074b8050&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "074b8050",
  null
  
)

export default component.exports